import React from 'react'
import dayjs from 'dayjs'
import { useGlobalState } from 'state'
import * as api from 'common/api'
import { IDs } from 'common/consts'
import { TimeSeriesRow } from 'common/types'
import { TimeSeriesSlider } from 'components/layers/TimeSeriesSlider'


export const KouzuiLayer = () => {
  const state = useGlobalState()
  const [sliderIndex, setSliderIndex] = React.useState(-1)
  const [sliderBaseDate, setSliderBaseDate] = React.useState<dayjs.Dayjs>(dayjs.utc())
  const [timeSeries, setTimeSeries] = React.useState<TimeSeriesRow[]>([])

  const sourceId = IDs.kouzui.source
  const layerId = IDs.kouzui.layer
  const displayLabelsHours = [-3, -2, -1, 0]

  React.useEffect(() => {
    load()
  }, [timeSeries])

  React.useEffect(() => {
    fetch()
  }, [state.app.baseDate])

  React.useEffect(() => {
    return () => {
      remove()
    }
  }, [])

  React.useEffect(() => {
    load()
  }, [sliderIndex])

  const remove = () => {
    state.map.removeLayer(layerId)
    state.map.removeSource(sourceId)
  }

  const load = () => {
    if (timeSeries.length === 0 || sliderIndex < 0 || timeSeries.length <= sliderIndex) {
      remove()
      return
    }

    const data = timeSeries[sliderIndex].url
    if (state.map.hasSource(sourceId)) {
      state.map.updateSourceData(sourceId, data)
    } else {
      state.map.addSource(sourceId, {
        type: 'geojson',
        data: data
      })
      state.map.addLayer({
        id: layerId,
        type: 'line',
        source: sourceId,
        layout: {},
        minzoom: 7,
        maxzoom: 18,
        paint: {
          'line-color': [
            'case',
            ['==', ['get', 'FLOODFCST'], '2'], 'rgb(242,231,0)',
            ['==', ['get', 'FLOODFCST'], '3'], 'rgb(255,40,0)',
            ['==', ['get', 'FLOODFCST'], '4'], 'rgb(170,0,170)',
            ['==', ['get', 'FLOODFCST'], '5'], 'rgb(12,0,12)',
            ['==', ['get', 'FLOODRISK'], '1'], 'rgb(242,231,0)',
            ['==', ['get', 'FLOODRISK'], '2'], 'rgb(255,40,0)',
            ['==', ['get', 'FLOODRISK'], '3'], 'rgb(170,0,170)',
            ['==', ['get', 'FLOODRISK'], '4'], 'rgb(12,0,12)',
            '#4ffeff'
          ],
          'line-width': [
            'match',
            ['get', 'FLOODFCST'],
            '1', 10,
            '2', 10,
            '3', 10,
            '4', 10,
            '5', 10,
            3
          ]
        },
      })
    }
  }

  React.useEffect(() => {
    state.mapbox?.on('style.load', load)
    return () => {
      state.mapbox?.off('style.load', load)
    }
  }, [load])

  const fetch = async () => {
    const res = await api.get('/river-risk', {date: state.app.getFormattedBaseDate(5)})
    if (res === null) {
      return
    }
    const rows: any[] = res.riverRisks
    const baseDateIndex = rows.findIndex(row => row.date === res.baseDate)
    setTimeSeries(rows)
    setSliderIndex(baseDateIndex)
    setSliderBaseDate(dayjs.utc(rows[baseDateIndex].date))

    load()
  }

  const sliderMoveend = (index: number) => {
    setSliderIndex(index)
  }

  return (
    <>
      <TimeSeriesSlider
        baseDate={sliderBaseDate}
        currentIndex={sliderIndex}
        timeSeries={timeSeries}
        displayLabelsHours={displayLabelsHours}
        moveend={sliderMoveend}
      />
    </>
  )
}
